module.exports = __webpack_public_path__ + "mainassets/img/double arrow-down-green.6e64ad72.svg";